(function($) {
	$('.edit-bio-btn').click(function(e) {
		e.preventDefault();
		$('.profile-edit-bio').toggleClass('editing');
	});
	
	var $tab_panels = $('.tab-panel');
	var $tabs = $('.profile-summary-tabs .tab');
	
	$tabs.click(function(e) {
		e.preventDefault();
		var id = $(this).attr('href');
		$tabs.closest('li').removeClass('active');
		$(this).parent().addClass('active');
		$tab_panels.removeClass('active');
		$tab_panels.filter(id).addClass('active');
	});
})(jQuery);